// Copy of the standalone Create a Campaign wizard (Figma 6566:9267). Strings the frames do not draw
// (Instant Reward, the Quest action step, the other four games) follow the drawn ones' pattern.
export const wizard = {
  launch: 'Launch a Campaign',
  subtitle: 'Lorem Ipsum is dummy text commonly used in graphic design, publishing',
  back: 'Back',
  reviewBack: 'back',
  step: 'Step {{step}}/{{total}}',
  jump: 'Back to step {{step}}/{{total}}',
  exit: 'Back to chat',
  edit: 'Edit',
  editSection: 'Edit {{section}}',
  createNew: {
    campaign: 'Create a new campaign',
    reward: 'Create a new reward',
    loyalty: 'Create a new loyalty program'
  },
  result: {
    draft: 'Draft saved',
    confirmed: 'Campaign created',
    pending: 'Submitted for approval',
    body: '{{name}} (id: {{id}})',
    view: 'View campaign',
    editCampaign: 'Edit campaign',
    request: 'View approval request',
    another: 'Create another'
  },
  next: 'Next',
  finalise: 'Finalise',
  saveDraft: 'Save as draft',
  confirm: 'Confirm',
  type: {
    title: 'Create a Campaign',
    stamp: 'Stamp Cards',
    progress: 'Progress Bar',
    quest: 'Quest Campaign',
    game: 'Gamified Mechanics',
    instant_outcome: 'Instant Reward'
  },
  objective: {
    title: 'What is your objective?',
    sales: 'Encourage More Sales',
    tasks: 'Drive users to Complete Tasks',
    habit: 'Build Habitual Engagement',
    upsell: 'Upsell Other Products'
  },
  create: {
    stamp: 'Create a Stamp Campaign',
    quest: 'Create a Quest Campaign',
    progress: 'Create a Progress Campaign',
    game: 'Create a Game Campaign',
    instant_outcome: 'Create an Instant Reward Campaign'
  },
  setup: {
    stamp: 'Let’s Setup your Stamp Card Campaign!',
    quest: 'Let’s Setup your Quest Campaign!',
    progress: 'Let’s Setup your Progress Campaign!',
    game: 'Let’s Setup your {{game}} Campaign!',
    instant_outcome: 'Let’s Setup your Instant Reward Campaign!'
  },
  ready: 'We’re Ready to Create your {{name}} Campaign!',
  readyName: {
    stamp: 'Stamp Card',
    quest: 'Quest',
    progress: 'Progress',
    instant_outcome: 'Instant Reward'
  },
  action: {
    question: {
      stamp: 'What do users need to do to earn a stamp?',
      quest: 'What do users need to do to complete the first task?',
      instant_outcome: 'What do users need to do to get a reward?'
    },
    transaction: 'Make a Transaction',
    loyalty: 'Earn or Redeem Loyalty Points',
    milestone: 'Join or Complete a Campaign',
    reward: 'Earn or Redeem Rewards',
    others: 'Something Else (Custom Action)'
  },
  trigger: {
    leadIn: {
      stamp: 'Users earn a stamp when they',
      quest: 'Users complete this task when they',
      progress: 'Users earn points when they',
      instant_outcome: 'Users get a reward when they'
    },
    questTask: 'Quest Campaign: Task {{n}}',
    // Progress rules read as tasks from 6985:4760 on; the data stays the module's `rules[]`.
    progressRule: 'Progress Campaign: Task {{n}}',
    transaction: {
      question: 'What kind of Transaction do users need to make?',
      amount: 'Make a transaction of at least',
      amountHint: 'Positive or negative numbers, max 2 decimal places',
      amountInvalid: 'Use a number with at most 2 decimal places',
      type: 'The transaction must be a',
      typePlaceholder: 'Transaction type',
      typeUnit: 'type',
      schedule: 'The transaction must take place on:',
      days: 'Specific days',
      months: 'Specific months',
      deadline: 'No later than',
      deadlineHint: 'Leave blank if no deadline',
      properties: 'The transaction must have properties:',
      propertyKey: 'Property key',
      propertyValue: 'Value',
      equals: 'Equals',
      notEquals: 'Not Equals',
      addCondition: 'Add condition',
      removeCondition: 'Remove condition',
      empty: 'Pick at least one condition'
    },
    loyalty: {
      question: 'What Loyalty Points Activity must users have?',
      earn: 'Earn Points'
    },
    milestone: {
      question: 'What Campaign Activity must users do?',
      selectCampaign: 'Select Campaign',
      game_redeemed: 'Play a game',
      game_try_issued: 'Earn a Game Try',
      campaign_enrolled: 'Enrol to a Campaign',
      campaign_completed: 'Complete a Campaign',
      campaign_not_completed: 'Did not Complete a Campaign',
      quest_task_completed: 'Completed a Quest Campaign Task'
    },
    reward: {
      question: 'What Reward Activity must users do?',
      any: 'Earn any Reward',
      specific: 'Earn a specific Reward',
      selected: 'Selected Reward',
      selectReward: 'Select Reward'
    },
    others: {
      question: 'What Custom Action must users do?',
      placeholder: 'Select a custom action'
    },
    progress: {
      basis: 'Users earn pts',
      perTransaction: 'per transaction',
      perAmount: 'per transaction amount',
      fixed: 'For every transaction, users earn',
      fixedUnit: 'pts towards the next milestone',
      variable: 'For every',
      variableSpent: 'spent, users earn',
      variableCap: 'pts, up to a maximum of',
      variableCapUnit: 'pts',
      pointsRequired: 'Set the points users earn',
      variableRequired: 'Set the amount and the most points a transaction earns'
    }
  },
  summary: {
    transaction: 'Make a Transaction of:',
    amount: 'Amount >= {{value}}',
    type: 'Type: {{value}}',
    days: 'On: {{value}}',
    months: 'In: {{value}}',
    deadline: 'No later than {{value}}',
    property: '{{key}} {{operator}} {{value}}',
    equals: 'EQUALS',
    notEquals: 'IS NOT',
    and: 'AND',
    loyalty: 'Earn Points',
    reward: 'Earn a Reward',
    rewardSpecific: 'Earn Reward {{name}} (id: {{id}})',
    campaign: '{{activity}} {{name}} (id: {{id}})',
    others: 'Custom Action {{name}}',
    points: '{{value}} pts'
  },
  tasks: {
    question: 'Do you want to add more tasks?',
    add: 'Add Task',
    modalTitle: 'Add Task',
    modalQuestion: 'Lets define the Task — What do users need to do?',
    cancel: 'Cancel',
    remove: 'Remove task {{n}}',
    reorder: 'Reorder task {{n}}',
    moveUp: 'Move task {{n}} up',
    moveDown: 'Move task {{n}} down',
    max: 'A quest has at most {{max}} tasks'
  },
  rules: {
    question: 'Do you want to add more tasks?',
    add: 'Add Task',
    modalTitle: 'Add Task',
    remove: 'Remove task {{n}}'
  },
  milestones: {
    question: 'How many milestones does this campaign have?',
    level: 'Level {{n}}',
    levelEnd: 'Level {{n}} (end)',
    points: 'Points for level {{n}}',
    add: 'Add milestone',
    removeLast: 'Remove last',
    ascending: 'Each level needs more points than the one before it'
  },
  prize: {
    stampQuestion: 'How many transactions do users need to make to get a prize?',
    questQuestion: 'What prize do users get upon completing all tasks?',
    levelQuestion: 'What prize do users get upon completing Level {{n}}?',
    instantQuestion: 'What prize do users get?',
    rule: 'Prize rule {{n}}',
    prize: 'Prize',
    levelPrize: 'Prize for Level {{n}}',
    slotLeadIn: 'Issue a Prize on earning the',
    slotUnit: 'stamp',
    getLeadIn: 'Users will get:',
    points: 'Points',
    reward: 'A Reward',
    award: 'Award',
    pointsFrom: 'points from',
    issue: 'Issue',
    selectReward: 'Select Reward',
    loyaltyOption: '{{name}} (id: {{id}})',
    addRule: 'Add prize rule',
    addPrize: 'Add prize',
    remove: 'Remove prize {{n}}',
    slotTaken: 'Another prize rule already uses this stamp',
    slotRange: 'A stamp card has at most {{max}} stamps',
    incomplete: 'Complete every prize'
  },
  game: {
    question: 'What type of Game Mechanic do you want?',
    shake_the_tree: 'Shake the Tree',
    hit_the_pinata: 'Hit the Pinata',
    scratch_card: 'Scratch Card',
    plinko: 'Plinko',
    spin_the_wheel: 'Spin the Wheel',
    wheel: {
      countQuestion: 'How many wedges do you want on the wheel?',
      countHint: 'Choose a number between 4 and 12. Each wedge will have its own outcome.',
      countTitle: 'Number of Wedges',
      countBody: 'Select the number of wedges for your Spin the Wheel campaign.',
      min: 'Minimum:',
      max: 'Maximum:',
      wedges: '{{n}} wedges',
      overModule:
        'Wheels of more than 8 wedges cannot be saved yet: the campaign module stops at 8.',
      range: 'Choose between 4 and 12 wedges',
      outcomesQuestion: 'Configure the outcome for each wedge on the wheel.',
      outcomesTitle: 'Wheel Outcomes',
      outcomesHint:
        '{{n}} wedges selected. Set an outcome for each wedge. Return to Step 3 to change the number of wedges.',
      wedge: 'Wedge {{n}}',
      noPrize: 'No Prize',
      oneWinner: 'Put a prize on at least one wedge'
    },
    modeQuestion: 'How should prizes be awarded?',
    random: 'Win a random prize',
    choice: 'Customers choose their prize when they win',
    choiceShort: 'Customers choose their prize',
    outcomes: 'Game Outcomes',
    outcomesHint: 'Define the prizes customers can win when they play.',
    outcome: 'Outcome {{n}}',
    addOutcome: 'Add Outcome',
    removeOutcome: 'Remove outcome {{n}}',
    noPrize: 'Customers can win no prize',
    noPrizeRow: 'No Prize',
    choiceNeedsTwo: 'Customers choosing their prize need at least 2 outcomes',
    probabilityQuestion: 'What are the win probabilities for each outcome?',
    probabilityHint:
      'Set a probability between 1% and 100% for each outcome. The total must equal 100%.',
    outcomeColumn: 'Outcome',
    probabilityColumn: 'Win probability',
    remaining: 'Total must equal 100% ({{n}}% remaining).',
    over: 'Total must equal 100% ({{n}}% over).',
    total: 'Total Probability',
    winQuestion: 'What is the probability of winning a prize?',
    win: 'Win Probability',
    winHint: 'Set the chance that a customer wins and can choose a prize.',
    winValue: 'Win probability: {{n}}%'
  },
  limits: {
    question: 'Any other limits?',
    stampCards: 'Limit the number of Stamp Cards to',
    stampCardsHint: 'First come, first served',
    stampPerUser: 'Each user can only get a max of',
    stampPerUserUnit: 'Stamp Cards',
    stampPerPeriod: 'Users can only earn',
    stampPerPeriodUnit: 'stamps per',
    questParticipants: 'Limit this quest to',
    questParticipantsUnit: 'participants.',
    questCompletions: 'Limit users to completing this quest',
    questCompletionsUnit: 'times.',
    autoIssue: 'Auto Issue Game Tries',
    on: 'On',
    off: 'Off',
    totalPlays: 'Total times the game can be played',
    userPlays: 'Users can only play this game',
    timesUnit: 'times',
    timesPer: 'times per',
    issuanceTotal: 'Limit the number of rewards issued to',
    issuancePerUser: 'Each user can only get a max of',
    issuanceRate: 'Issue at most',
    issuanceUserRate: 'Each user can get at most',
    rewardsUnit: 'rewards',
    rewardsPer: 'rewards per',
    autoRedeem: 'Redeem the reward automatically',
    enrolment: 'All eligible users:',
    autoEnrol: 'Are enrolled automatically',
    selfEnrol: 'Must enrol themselves',
    enrolBy: 'No later than:',
    window: {
      quest: 'Users must complete this Quest within',
      progress: 'Users must complete this campaign within'
    },
    windowUnit: 'days',
    start: 'Start this Campaign on:',
    end: 'End this campaign on:',
    endBeforeStart: 'The end must be after the start',
    positive: 'Use a whole number of 1 or more',
    period: {
      day: 'day',
      week: 'week',
      month: 'month',
      year: 'year'
    }
  },
  review: {
    question: 'Let’s make sure we got everything right…',
    name: 'Campaign Name',
    namePlaceholder: 'Name this campaign',
    nameRequired: 'Name this campaign',
    saveFailed: 'The campaign could not be saved. Try again.',
    start: 'Campaign Start',
    end: 'Campaign End',
    never: 'Never',
    now: 'As soon as it is confirmed',
    trigger: 'Trigger',
    task: 'Task {{n}}',
    rule: 'Task {{n}}',
    rewards: 'Rewards',
    levelPrize: 'Level {{n}} — {{prize}}',
    limits: 'Limits',
    enrolment: 'Enrolment',
    automatic: 'Automatic',
    selfEnrol: 'Users enrol themselves',
    selfEnrolBy: 'Users enrol themselves, until {{date}}',
    gameType: 'Game Type',
    prizeMode: 'Prize Mode',
    outcomes: 'Game Outcomes',
    probabilityTotal: 'Probability Total',
    gameTries: 'Game Tries',
    wedgeCount: 'Number of Wedges',
    wedgeOutcomes: 'Wedge Outcomes',
    autoIssue: 'Auto Issue Game Tries: {{state}}',
    finalSlot: 'FINAL SLOT',
    slot: 'Slot {{slot}} — {{prize}}',
    issuePoints: 'Issue {{count}} points (Loyalty ID {{id}})',
    awardPoints: 'Award {{count}} points from {{name}}',
    issueReward: 'Issue Reward {{name}} (id: {{id}})',
    withProbability: '{{prize}} — {{n}}%',
    noPrize: 'No Prize — {{n}}%',
    noLimit: 'No limit',
    maxCards: 'Max Stamp Cards: {{value}}',
    maxCardsPerUser: 'Max Stamp Cards per person: {{value}}',
    maxEarns: 'Max Stamp Earns: {{value}} per person per {{period}}',
    participants: 'Participants: {{value}}',
    completions: 'Completions per user: {{value}}',
    window: 'Complete within {{value}} days',
    totalPlays: 'Total game plays: {{value}}',
    userPlays: 'Plays per user: {{value}}',
    userPlaysCap: 'Plays per user: {{value}}; frequency cap: {{cap}}',
    capValue: '{{value}} per {{period}}',
    capNone: 'None',
    issuedTotal: 'Rewards issued: {{value}}',
    issuedPerUser: 'Rewards per user: {{value}}',
    issuedRate: 'Rewards per {{period}}: {{value}}',
    issuedUserRate: 'Rewards per user per {{period}}: {{value}}',
    autoRedeem: 'Redeemed automatically: {{state}}',
    yes: 'Yes',
    no: 'No',
    none: '—'
  }
};
